export default angular.module('suggested_links_module', []);